import { render } from "./TextReaderOficina.vue?vue&type=template&id=2008b13b"
import script from "./TextReaderOficina.vue?vue&type=script&lang=js"
export * from "./TextReaderOficina.vue?vue&type=script&lang=js"

import "./TextReaderOficina.vue?vue&type=style&index=0&id=2008b13b&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__